import { type FC } from 'react';
import classnames from 'classnames';
import { defineMessages, useIntl, FormattedDate } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import { Badge } from 'dibs-elements/exports/Badge';

import { NftItemTilePrice, type Props as NftItemTilePriceProps } from './NftItemTilePrice';

import styles from './styles/NftItemTileMostRecentBid.scss';

const messages = defineMessages({
    title: {
        id: 'nftItemTile.mostRecentBid.title',
        defaultMessage: 'your last action',
    },
    leader: {
        id: 'nftItemTile.mostRecentBid.leader',
        defaultMessage: 'Highest Bidder',
    },
    bidPlaced: {
        id: 'nftItemTile.mostRecentBid.bidPlaced',
        defaultMessage: 'Bid placed for {priceText}',
    },
});

type PriceProps = Pick<NftItemTilePriceProps, 'etherAmount' | 'etherRates' | 'currency'>;

export const NftItemTileMostRecentBidLeaderCta: FC<
    PriceProps & {
        pdpUrl: string;
        isLeader: boolean;
        bidDate?: string | null;
        onClick?: () => void;
        withPadding?: boolean;
    }
> = ({
    pdpUrl,
    isLeader,
    currency,
    onClick,
    bidDate,
    etherAmount = null,
    etherRates = null,
    withPadding = false,
}) => {
    const intl = useIntl();
    return (
        <Link href={pdpUrl} className={styles.link} onClick={onClick}>
            <div
                className={classnames(styles.contentContainer, {
                    [styles.withPadding]: withPadding,
                })}
            >
                <div className={styles.titleContainer}>
                    <span className={styles.title}>{intl.formatMessage(messages.title)}</span>
                    {isLeader ? (
                        <Badge type="pill" size="small-heavy">
                            {intl.formatMessage(messages.leader)}
                        </Badge>
                    ) : null}
                </div>

                {bidDate && (
                    <span className={styles.date}>
                        <FormattedDate
                            value={bidDate}
                            month="long"
                            day="numeric"
                            hour="numeric"
                            minute="numeric"
                            hour12
                        />
                    </span>
                )}
                <p>
                    {intl.formatMessage(messages.bidPlaced, {
                        priceText: (
                            <NftItemTilePrice
                                etherAmount={etherAmount}
                                etherRates={etherRates}
                                currency={currency}
                                key={`nft-price-${pdpUrl}`}
                            />
                        ),
                    })}
                </p>
            </div>
        </Link>
    );
};
